var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v("Ruta " + _vm._s(_vm.form.nombre))]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "I",
                    expression: "estado === 'I'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("INACTIVA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "A",
                    expression: "estado === 'A'"
                  }
                ],
                staticClass: "noti-success"
              },
              [_c("strong", [_vm._v("ACTIVA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "N",
                    expression: "estado === 'N'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_c("strong", [_vm._v("NUEVA")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.puede_consultar_rutas ||
                      _vm.puede_editar_ruta ||
                      _vm.puede_eliminar_ruta,
                    expression:
                      "\n            puede_consultar_rutas || puede_editar_ruta || puede_eliminar_ruta\n          "
                  }
                ],
                staticClass: "btn-info btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c("div", { staticClass: "layout__main-form" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            readonly: _vm.estado !== "N",
                            placeholder: "Escriba un código...",
                            id: "codigo",
                            name: "codigo"
                          },
                          model: {
                            value: _vm.form.codigo,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "codigo", $$v)
                            },
                            expression: "form.codigo"
                          }
                        },
                        [
                          _c("span", [_vm._v("Código*")]),
                          _vm._v(" "),
                          _vm.errores.codigo
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.codigo[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            placeholder: "Seleccione...",
                            options: _vm.bodegas,
                            id: "bodega",
                            name: "bodega",
                            label: "descripcion"
                          },
                          on: { input: _vm.inputBodega },
                          model: {
                            value: _vm.selectedBodega,
                            callback: function($$v) {
                              _vm.selectedBodega = $$v
                            },
                            expression: "selectedBodega"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "bodega" } }, [
                          _vm._v("Sucursal*")
                        ]),
                        _vm._v(" "),
                        _vm.errores.bodega_id
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.bodega_id[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            placeholder: "Escriba un nombre...",
                            id: "nombre",
                            name: "nombre"
                          },
                          model: {
                            value: _vm.form.nombre,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "nombre", $$v)
                            },
                            expression: "form.nombre"
                          }
                        },
                        [
                          _c("span", [_vm._v("Nombre*")]),
                          _vm._v(" "),
                          _vm.errores.nombre
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.nombre[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "textarea-field",
                        {
                          attrs: {
                            placeholder: "Escriba una o varias direcciones...",
                            id: "direcciones"
                          },
                          model: {
                            value: _vm.form.direcciones,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "direcciones", $$v)
                            },
                            expression: "form.direcciones"
                          }
                        },
                        [
                          _c("span", [_vm._v("Direcciones*")]),
                          _vm._v(" "),
                          _vm.errores.direcciones
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.direcciones[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            placeholder: "Seleccione...",
                            options: _vm.recaudadores,
                            id: "recaudador",
                            name: "recaudador",
                            label: "descripcion"
                          },
                          on: {
                            input: _vm.inputRecaudador,
                            search: _vm.searchRecaudadores
                          },
                          model: {
                            value: _vm.selectedRecaudador,
                            callback: function($$v) {
                              _vm.selectedRecaudador = $$v
                            },
                            expression: "selectedRecaudador"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "recaudador" } }, [
                          _vm._v("Recaudador*")
                        ]),
                        _vm._v(" "),
                        _vm.errores.recaudador_id
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.recaudador_id[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("geocercas", {
                  attrs: { clientes: _vm.form.clientes },
                  model: {
                    value: _vm.form.geocercas,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "geocercas", $$v)
                    },
                    expression: "form.geocercas"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("vendedores-ruta", {
                  model: {
                    value: _vm.form.vendedores,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "vendedores", $$v)
                    },
                    expression: "form.vendedores"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.estado === "N" && _vm.puede_crear_ruta) ||
                        (_vm.estado !== "N" && _vm.puede_editar_ruta),
                      expression:
                        "\n              (estado === 'N' && puede_crear_ruta) ||\n              (estado !== 'N' && puede_editar_ruta)\n            "
                    }
                  ],
                  staticClass: "btn-success btn--bigger",
                  attrs: { type: "button" },
                  on: { click: _vm.guardar }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.puede_crear_ruta,
                      expression: "puede_crear_ruta"
                    }
                  ],
                  staticClass: "btn-light btn--text",
                  on: { click: _vm.nueva }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _c("span", [_vm._v("Nueva")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.puede_clonar_ruta && _vm.estado !== "N",
                      expression: "puede_clonar_ruta && estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-secondary btn--text",
                  on: { click: _vm.clonar }
                },
                [
                  _c("i", { staticClass: "fa fa-clone" }),
                  _c("span", [_vm._v("Clonar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N" && _vm.puede_eliminar_ruta,
                      expression: "estado !== 'N' && puede_eliminar_ruta"
                    }
                  ],
                  staticClass: "btn--text",
                  class: {
                    "btn-danger": _vm.estado === "A",
                    "btn-success": _vm.estado === "I"
                  },
                  attrs: { type: "button" },
                  on: { click: _vm.inactivar }
                },
                [
                  _c("i", { staticClass: "fa fa-ban" }),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.estado === "I" ? "Re-activar" : "Inactivar")
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "listaRutas",
            height: "auto",
            width: "65%",
            scrollable: "",
            resizable: "",
            adaptive: "",
            reset: ""
          }
        },
        [
          _c("lista-rutas", {
            ref: "listaRutas",
            on: {
              seleccionar: _vm.seleccionarRuta,
              cerrar: _vm.cerrarListaRutas
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la ruta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Geocercas")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Vendedores")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4b635be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4b635be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/rutas/Ruta.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d4b635be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/rutas/Ruta.vue
// module chunks = 0